import { useQuery } from '@tanstack/react-query';
import { PromoItemZmsView } from '@/features/promotion/components/PromoItemZmsView';
import type { PromoDrillParams } from '@/features/promotion/types/promotion.types';
import { distributedMpItemQueryOptions } from '../api/marketPromotion.api';

const UNKNOWN_PROMOTION_TITLE = 'Promotion';

interface MpItemZmsPageProps {
  promoItemId: number;
  zmSearch: PromoDrillParams;
}

export function MpItemZmsPage({ promoItemId, zmSearch }: MpItemZmsPageProps) {
  const promotionQuery = useQuery(distributedMpItemQueryOptions(promoItemId, zmSearch));
  const title = promotionQuery.isLoading
    ? undefined
    : (promotionQuery.data?.name ?? UNKNOWN_PROMOTION_TITLE);

  return (
    <PromoItemZmsView
      unit="marketPromotion"
      promoItemId={promoItemId}
      zmSearch={zmSearch}
      title={title}
    />
  );
}
